import { render, staticRenderFns } from "./TeamForum.vue?vue&type=template&id=07db80e4&scoped=true"
import script from "./TeamForum.vue?vue&type=script&lang=js"
export * from "./TeamForum.vue?vue&type=script&lang=js"
import style0 from "./TeamForum.vue?vue&type=style&index=0&id=07db80e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db80e4",
  null
  
)

export default component.exports